export { CardClickable, type CardClickableProps } from "./CardClickable";
